// capture whitelabel only once

const LOGIN_MODAL_EVENTS = {
  INIT_EXTERNAL_WALLETS: "INIT_EXTERNAL_WALLETS",
  LOGIN: "LOGIN",
  DISCONNECT: "DISCONNECT",
  MODAL_VISIBILITY: "MODAL_VISIBILITY"
};
const MODAL_STATUS = {
  INITIALIZED: "initialized",
  CONNECTED: "connected",
  CONNECTING: "connecting",
  ERRORED: "errored"
};
const DEFAULT_LOGO_LIGHT = "https://images.web3auth.io/web3auth-logo-w.svg"; // logo used on light mode
const DEFAULT_LOGO_DARK = "https://images.web3auth.io/web3auth-logo-w-light.svg"; // logo used on dark mode

const WALLET_CONNECT_LOGO = "https://images.web3auth.io/login-wallet-connect.svg";

export { DEFAULT_LOGO_DARK, DEFAULT_LOGO_LIGHT, LOGIN_MODAL_EVENTS, MODAL_STATUS, WALLET_CONNECT_LOGO };
